import { ApiError } from "./ApiError-DO51S3eN.js";

//#region src/errors/HinokuniError.ts
function getHinokuniErrorFromMessage(message, detail) {
	if (message === "ValidationError") return detail.__all__ ?? "";
	if (message === "ProtectedError") return `This object is used by another resource, you cannot delete it`;
	return message;
}
function getHinokuniErrorMessageFromDetail(detail) {
	switch (typeof detail) {
		case "string": return detail;
		case "object":
			if (Array.isArray(detail)) {
				if (typeof detail[0] === "string") return detail[0];
				else if (typeof detail[0] === "object" && detail[0].msg) return detail[0].msg;
				return void 0;
			} else if (detail?.workflow) return detail.workflow[0];
			return void 0;
		default: return void 0;
	}
}
function getHinokuniErrorMessageFromBody(body) {
	return body ? getHinokuniErrorMessageFromDetail(body.detail) ?? getHinokuniErrorFromMessage(body.message, body.detail) : void 0;
}
function getHinokuniFallbackErrorMessage({ status }) {
	switch (status) {
		case 402: return "Payment Required";
		case 404: return "Not Found";
		case 423: return "This object is locked, you are not allowed to make any changes";
		case 400:
		case 409:
		case 422:
		default: return "Unknown Error";
	}
}
function getHinokuniErrorMessage({ body, status }) {
	switch (status) {
		case 401: return "Unauthorized";
		case 402: return body.message;
		case 403: return "Forbidden";
		case 404: return getHinokuniErrorMessageFromBody(body);
		case 422: return body.detail?.msg ?? getHinokuniErrorMessageFromBody(body);
		case 423: return body.message;
		case 429: return "You have tried this too many times, please retry later";
		case 400:
		case 409: return getHinokuniErrorMessageFromBody(body);
		case 500: return "Internal Server Error";
		default: return void 0;
	}
}
var HinokuniError = class extends ApiError {
	constructor(error) {
		super(error, getHinokuniErrorMessage, getHinokuniFallbackErrorMessage);
	}
	getChildren() {
		const errors = {};
		if (this.status === 400 && this.body.message === "ValidationError") for (const key in this.body.detail) {
			if (key === "__all__") continue;
			errors[key] = new Error(this.body.detail[key]);
		}
		else if (this.status === 422 && Array.isArray(this.body.detail)) for (const error of this.body.detail) {
			const key = error.loc.at(-1);
			errors[key] = new Error(error.msg);
		}
		return errors;
	}
};

//#endregion
export { HinokuniError };